import { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';
import '../../../../styles/contact-modal.css';

interface PhoneBlockProps {
  initial?: string;
  onChange: (v: string) => void;
}

export default function PhoneBlock({ initial, onChange }: PhoneBlockProps) {
  const [phone, setPhone] = useState<string>(initial ?? '');
  const [editing, setEditing] = useState<boolean>(Boolean(initial));
  const [type, setType] = useState<'mobile' | 'work' | 'home'>('mobile');

  useEffect(() => {
    setPhone(initial ?? '');
    setEditing(Boolean(initial));
  }, [initial]);

  const handlePhoneChange = (newPhone: string) => {
    setPhone(newPhone);
    onChange(newPhone);
  };

  if (!editing) {
    return (
      <div className="cm-box cm-add">
        <button
          style={{ background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer' }}
          onClick={() => {
            setEditing(true);
            setPhone('');
          }}
        >
          + add phone
        </button>
      </div>
    );
  }

  return (
    <div className="cm-box">
      <div className="cm-box-left">
        <Phone size={18} className="cm-box-icon" />
        <input
          className="cm-box-input"
          placeholder="+1 212 345 6789"
          value={phone}
          onChange={(e) => handlePhoneChange(e.target.value)}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '12px' }}>
        <select
          value={type}
          onChange={(e) => setType(e.target.value as 'mobile' | 'work' | 'home')}
          className="cm-select"
        >
          <option value="mobile">mobile</option>
          <option value="work">work</option>
          <option value="home">home</option>
        </select>
        <button
          aria-label="Remove phone"
          className="cm-icon-btn"
          onClick={() => {
            setEditing(false);
            setPhone('');
            onChange('');
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}

